import _ from 'lodash'

/**
 * Unwraps a Backbone.Model, or if the passed in object isn't a Backbone.Model,
 * returns the passed-in object unchanged.
 *
 * @param {Backbone.Model|Object} backboneModelOrObject
 * @return {Object} Model.attributes or the object passed if not a Model
 */
function unwrapModel(backboneModelOrObject) {
	return _.get(backboneModelOrObject, 'attributes', backboneModelOrObject)
}

export default unwrapModel

unwrapModel.__filename__ = 'components/unwrap-model.js'
